import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={styles.footer}>
      <div className="container">
        <div style={styles.content}>
          {/* Logo and Description */}
          <div style={styles.section}>
            <div style={styles.logoContainer}>
              <img 
                src="https://customer-assets.emergentagent.com/job_redcross-funding/artifacts/ikgacwfy_IMG_9082.jpeg" 
                alt="WAHR Logo" 
                style={styles.logo}
              />
            </div>
            <p style={styles.description}>
              Professionelles Coaching für Door-to-Door Fundraising.
              In 2 Wochen zum Experten.
            </p>
          </div>
          
          {/* Quick Links */}
          <div style={styles.section}>
            <h4 style={styles.sectionTitle}>Quick Links</h4>
            <nav style={styles.nav}>
              <a href="#about" style={styles.link}>Über das Coaching</a>
              <a href="#services" style={styles.link}>Leistungen</a>
              <a href="#testimonials" style={styles.link}>Referenzen</a>
              <a href="#booking" style={styles.link}>Termin buchen</a>
            </nav>
          </div>
          
          {/* Legal Links */}
          <div style={styles.section}>
            <h4 style={styles.sectionTitle}>Rechtliches</h4>
            <nav style={styles.nav}>
              <Link to="/impressum" style={styles.link}>Impressum</Link>
              <Link to="/datenschutz" style={styles.link}>Datenschutzerklärung</Link>
            </nav>
          </div>
          
          {/* Contact Info */}
          <div style={styles.section}>
            <h4 style={styles.sectionTitle}>Kontakt</h4>
            <div style={styles.contactInfo}>
              <div style={styles.contactItem}>
                <Mail size={18} color="var(--brand-primary)" />
                <a href="mailto:Nicolas.wahr@icloud.com" style={styles.contactLink}>
                  Nicolas.wahr@icloud.com
                </a>
              </div>
              <div style={styles.contactItem}>
                <Phone size={18} color="var(--brand-primary)" />
                <a href="tel:+491746429886" style={styles.contactLink}>
                  +49 174 6429886
                </a>
              </div>
              <div style={styles.contactItem}>
                <MapPin size={18} color="var(--brand-primary)" />
                <span>Mittelstraße 11<br />40789 Monheim am Rhein</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div style={styles.bottom}>
          <p style={styles.copyright}>
            © {currentYear} Nicolas Alexander Wahr - WAHR Privatinstitut für Dialog & Markenkompetenz. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: 'var(--brand-dark)',
    color: 'white',
    padding: '64px 0 32px',
  },
  content: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '48px',
    marginBottom: '48px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  logoContainer: {
    width: '80px',
    height: '80px',
    background: 'white',
    borderRadius: '12px',
    padding: '8px',
    marginBottom: '8px',
  },
  logo: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  description: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '8px',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  link: {
    color: 'rgba(255, 255, 255, 0.8)',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.2s ease',
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  contactLink: {
    color: 'rgba(255, 255, 255, 0.8)',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
  },
  bottom: {
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    paddingTop: '24px',
    textAlign: 'center',
  },
  copyright: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.6)',
  },
};

// Add hover styles
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  footer a:hover {
    color: var(--brand-primary) !important;
  }
`;
document.head.appendChild(styleSheet);

export default Footer;